<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
      [{"num_cand":"U2FsdGVkX1/8B04DeS3GoknnD2SUj3dL/CLYCpGZCAI=","cpf":"U2FsdGVkX1/4TJRsJZI7cdpHjtsW/Ejpb57LX9Dtr6w="},{"num_cand":"U2FsdGVkX1+0g8+60LUjQQ1iI1sU7gNa7HDAilulmAA=","cpf":"U2FsdGVkX1/XaBJ8mOjEgNufcnfDcTkjKJt1dv7NnGk="},{"num_cand":"U2FsdGVkX1/gyrrVNR+T+ucTWjmpfyB+2yNv5wJXHFc=","cpf":"U2FsdGVkX1+0RsRLxEviXz3isTj8VHunlvg0SuzNpXA="},{"num_cand":"U2FsdGVkX1/nJKUd85cDkTz6+4eCGNg9yHphVslchsY=","cpf":"U2FsdGVkX1/pM+3FClsgXUS8forzn71wRPZchfXVarE="},{"num_cand":"U2FsdGVkX1+nFkxDoU8nIuCF8tnbDCL2kPIgB/ectos=","cpf":"U2FsdGVkX19dWfTbQ6SejpGjW8lcxhFnEj54vNoxico="},{"num_cand":"U2FsdGVkX18smd7W6nPwlf8y6J6EWEmYB3s3FVl/zUo=","cpf":"U2FsdGVkX19WY3RAxQetmLf4eNNypYD+PNJ7lojGv1s="},{"num_cand":"U2FsdGVkX18C9oyY5egEBTcL/iv+Hu8O1x4gmsph75I=","cpf":"U2FsdGVkX18KVxPoSraP1EvOpDK4bBV1x73OPP4PA1U="},{"num_cand":"U2FsdGVkX1+QNJtj99HKp1qkIqbpNBjETF7FjKZ0jaI=","cpf":"U2FsdGVkX19fd1tFhQsumn4CIcIL6GTt2iRb0WVEEv8="},{"num_cand":"U2FsdGVkX19h5QBm5b3z+E0q6qUVMtCL2uGsEYn2wow=","cpf":"U2FsdGVkX1+gnJ8EmBblEsMdn35z8DR13XlGFXWsdp0="},{"num_cand":"U2FsdGVkX19/TS5txxdKfwHm1dlkCOTjlUwsPF6Jv8c=","cpf":"U2FsdGVkX1+na38mjL8KY7KYNUb1+dCc0c4Nccwj9R0="},{"num_cand":"U2FsdGVkX1/H3Qro6m0lP8W5pNtidk5efbWaGQ8fcyo=","cpf":"U2FsdGVkX198sp8SjF0OccGVLNz8D0fUjllrfbiJPck="},{"num_cand":"U2FsdGVkX19AGyCzShjW603E+QpAj7FANjs37uEt/sg=","cpf":"U2FsdGVkX180qplbuXQgEQO1RaVmTjLEN4yYr/ejh1E="},{"num_cand":"U2FsdGVkX1/RpgQc/hgL5L6ycA2jNwL5mqHO8Loyoy0=","cpf":"U2FsdGVkX1/Wj0Pw0zl/Nku18cNnOV2tavzOtAN3ljY="},{"num_cand":"U2FsdGVkX1+zKKVmuuh246q+GPUqTgFUbPXwcz1qdqE=","cpf":"U2FsdGVkX1+e4nAG1C/2KfPVYM7Pg3T0E6UDhw6JL80="},{"num_cand":"U2FsdGVkX18BCFauMGm3+bGel+e96d3WeE4MQ7ZFIos=","cpf":"U2FsdGVkX18ajaHp6xuZ65h4Q/UOTJzdY3cF2en/H3k="},{"num_cand":"U2FsdGVkX1/6uEmxncWd3igbOWvt3jaXKjTISBE6M/g=","cpf":"U2FsdGVkX19lFxFBpa/SgsqFRerxzyxysbqqmL201fE="},{"num_cand":"U2FsdGVkX18EgyXF0+7YTffCoEzmXzfw1IzlWDA9hB4=","cpf":"U2FsdGVkX1+Yh3kzZBb8Toz2IgcBxoP4GwMymGh7N0k="},{"num_cand":"U2FsdGVkX1/6J03TfLhMLF3BplK4CGx2trjQ7/sUyuA=","cpf":"U2FsdGVkX1/AlSsH0AfsvdqCf2KEhc+JUjbTRGp4eRA="},{"num_cand":"U2FsdGVkX1+wAYeKCk858LqaY/NZHK/0X86Z6u+hDSU=","cpf":"U2FsdGVkX18cyvc6X8JdHQ2Bw3vzkQGFnlZct0WtiSc="},{"num_cand":"U2FsdGVkX19LUE+eiRVXMDAM3z6p+8Pcv95JWDX0QLQ=","cpf":"U2FsdGVkX197vDdm9b6MYE89LukkutKjX0UicMJRfNk="},{"num_cand":"U2FsdGVkX1+tW7sL2Edd2d6+t8Md5inlNIgxE5GbcZc=","cpf":"U2FsdGVkX1+DH1/2Lmelz4cXoUO5A1PJIDG5WX43UU8="},{"num_cand":"U2FsdGVkX1/tCM6xRDF16kNnlCVwjcFjPpYfLK0+2zs=","cpf":"U2FsdGVkX1+4i8ia1ykuetov7bsw2PD2/RZqDpCGgW4="},{"num_cand":"U2FsdGVkX18kN8UIj/xb2brZZFUevUxhsfcrnS5gDEo=","cpf":"U2FsdGVkX1+L5fZwqGdyEVSVasF0KS2rYvRQSGleiKA="},{"num_cand":"U2FsdGVkX19r0YyJU8qra4PPId4uFDoHqcgDiCvw1Tw=","cpf":"U2FsdGVkX1/lAbGUnIRat3g29acRmaOMF67UOfIkO+4="},{"num_cand":"U2FsdGVkX1/F2AO2iB32j1zxvZ82HE9cOBS/seE1fwg=","cpf":"U2FsdGVkX1+Kk6env6TTz5mKeAYpQrduR1YJrXn+GLM="},{"num_cand":"U2FsdGVkX1+qXqiIMq0V2EIMVDrjVBHtpyCdk8UrRQE=","cpf":"U2FsdGVkX18PWGO0u+lV1YmRbOrAnvJrNHxr7xeQ680="},{"num_cand":"U2FsdGVkX19w8TwpeOlh9AhT0qw/WSyIYswUsmQKxT4=","cpf":"U2FsdGVkX18nLPUsNRcqPKskn7JJH0r8WysDpt2/knw="},{"num_cand":"U2FsdGVkX1/aMyO9TAytdUYaKLvPH/8yok506m8zBVU=","cpf":"U2FsdGVkX19WhQkMz3khENjTnqPm5RXcuStR8Po3oYQ="},{"num_cand":"U2FsdGVkX19coqgmuPXGVHp+g7734edsmBuADkzGGtU=","cpf":"U2FsdGVkX1+hsG3jB+qpQt79J/VNjvB5ZI/nbNHrxss="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2215/rec_isenc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
